import { __decorate, __param, __metadata, __awaiter } from '../../_virtual/_tslib.js';
import { HttpClient } from '@hub-la/fe-core-http-client';
import { inject } from 'inversify';
import { GetMyAccess } from './get-my-access.js';

let HasAccountsAccess = class HasAccountsAccess {
  constructor(httpClient) {
    this.httpClient = httpClient;
  }
  execute() {
    return __awaiter(this, void 0, void 0, function* () {
      const data = yield new GetMyAccess(this.httpClient).execute();
      return (data !== null && data !== void 0 ? data : []).length > 0;
    });
  }
};
HasAccountsAccess = __decorate([__param(0, inject(HttpClient)), __metadata("design:paramtypes", [HttpClient])], HasAccountsAccess);

export { HasAccountsAccess };
